module.exports = __webpack_public_path__ + "img/v.cde43a05.svg";